import { QarepaEnumInformation } from '@qarepa/common';

export enum AbsenceTypeEnum {
  HOLIDAYS = 'HOLIDAYS',
  SICKNESS = 'SICKNESS',
  OTHER = 'OTHER',
}

export type AbsenceTypeType =
  AbsenceTypeEnum.HOLIDAYS | AbsenceTypeEnum.SICKNESS | AbsenceTypeEnum.OTHER;

export const AbsenceTypeArray = [
  AbsenceTypeEnum.HOLIDAYS,
  AbsenceTypeEnum.SICKNESS,
  AbsenceTypeEnum.OTHER,
];

export const AbsenceTypeInfo: QarepaEnumInformation<AbsenceTypeEnum> = {
  [AbsenceTypeEnum.HOLIDAYS]: {
    name: $localize`Vacaciones`,
  },

  [AbsenceTypeEnum.SICKNESS]: {
    name: $localize`Enfermedad`,
  },

  [AbsenceTypeEnum.OTHER]: {
    name: $localize`Otro`,
  },
};
